import { Box, CircularProgress, useMediaQuery } from "@mui/material";
import Axios from "axios";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { getToken } from "./api/token";
import Sidebar from "./components/sidebar/sidebar";
import SigninGruop from "./pages/signinGruop";

import "./styles/global.css";

import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDigest } from "./api/user";
import { ForgetPassword, PersonSignup, SignIn } from "./pages";
import Parvandeh from "./pages/area/parvandeh";

import AccontsTrip from "./pages/leaderGroup/accontsTrip";
import DashboardTrip from "./pages/leaderGroup/dashboard";
import Drug from "./pages/leaderGroup/drug";
import Equipment from "./pages/leaderGroup/equipment";
import Erja from "./pages/leaderGroup/erja";
import TripsPage from "./pages/leaderGroup/tripsPage";
import Reports from "./pages/reports";

import {
  AdultEducation,
  ChildrenEducation,
  DashboardArea,
  DrugTableArea,
  Insurer,
  Qarbal,
  Reception,
  Secretaries,
} from "./components";
import DrugTableInArea from "./components/areaManager/sidebarArea/drug/drugTableInArea";
import EquipmentsInArea from "./components/areaManager/sidebarArea/drug/EquipmentsInArea";
import Main from "./components/Main";
import { MyProvider } from "./MyContext";
import GroupSignup from "./pages/auth/groupSignupComponent/GroupSignup";
import Icons from "./pages/icons";

const AdminDashboard = lazy(() => import("./pages/admin/dashboard/Dashboard"));
const Notes = lazy(() => import("./pages/note/Notes"));
const Groups = lazy(() => import("./pages/Groups"));
const Users = lazy(() => import("./pages/Users"));
const Reporters = lazy(() => import("./pages/admin/reporters/List"));
const CreateProject = lazy(() => import("./pages/admin/project/CreateProject"));
const Projects = lazy(() => import("./pages/admin/project/Project"));
const Accesses = lazy(() => import("./pages/leaderGroup/accesses/Accesses"));
const CompleteArea = lazy(() => import("./pages/area/CompleteArea"));
const Notifications = lazy(
  () => import("./components/areaManager/notification/Notifications"),
);
const MyNotifications = lazy(
  () => import("./components/areaManager/notification/MyNotifications"),
);
const Profile = lazy(() => import("./pages/auth/profile/Profile"));

// export const BaseUrl = "http://127.0.0.1:8081";
export const BaseUrl = "https://asar.app";
export const apiAgent = Axios.create({ baseURL: BaseUrl });
export const apiAgentWithToken = Axios.create({ baseURL: BaseUrl });

apiAgent.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiAgentWithToken.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (!config.headers.Authorization && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

function App() {
  const [digest, setDigest] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.indexOf("signup") === -1 &&
      location.pathname.indexOf("forgetPassword") === -1 &&
      location.pathname.indexOf("login") === -1 &&
      !getToken()
    ) {
      navigate("/login");
    }
  }, [getToken(), location.pathname]);

  const fetchUserDigest = useCallback(() => {
    if (!localStorage.getItem("emr_token")) {
      setDigest(undefined);
      return;
    }

    getDigest()
      .then((x) => {
        setDigest(x);
      })
      .catch(() => {
        setDigest(undefined);
      });
  }, [localStorage]);

  useEffect(() => {
    fetchUserDigest();
  }, [getToken()]);

  const md = useMediaQuery("(max-width:450px)");
  const [showSidebar, setShowSidebar] = useState(!md);

  useEffect(() => {
    if (showSidebar && md) setShowSidebar(false);
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Box
        display="flex"
        sx={{
          height: "100vh",
          overflow: "hidden",
          backgroundColor: "var(--emr-background-color)",
        }}
      >
        {window.location.pathname !== "/login" &&
          window.location.pathname !== "/signin" &&
          window.location.pathname !== "/signup" &&
          window.location.pathname !== "/signup/group" &&
          window.location.pathname !== "/signup/group2" &&
          window.location.pathname !== "/signup/person" &&
          window.location.pathname !== "/forgetPassword" &&
          window.location.pathname !== "/parvandeh" &&
          showSidebar && (
            <>
              <Sidebar onClose={() => setShowSidebar(false)} Role={digest} />
            </>
          )}
        <Suspense fallback={<CircularProgress />}>
          <MyProvider>
            <Routes>
              <Route path="/login" element={<SignIn />} />
              <Route path="/forgetPassword" element={<ForgetPassword />} />
              <Route path="/signup/person" element={<PersonSignup />} />
              <Route path="/signup/group" element={<GroupSignup />} />
              <Route path="/signup/group2" element={<SigninGruop />} />
              <Route
                path="/profile"
                element={
                  <Main digest={digest} setShowSidebar={setShowSidebar}>
                    <Profile role={digest?.role ?? "USER"} />
                  </Main>
                }
              />

              {digest && (
                <>
                  <Route
                    path="/icons"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<Icons />}
                      />
                    }
                  />

                  <Route
                    path="/notes"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title={"یادداشت‌ها"}
                        digest={digest}
                        childNode={<Notes />}
                      />
                    }
                  />
                  <Route
                    path="reports"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="گزارشات"
                        digest={digest}
                        childNode={
                          <>
                            {digest?.role === "ADMIN" && (
                              <Reports role={digest} />
                            )}
                            {(digest?.role === "GROUP" ||
                              digest?.role === "JAHADI") && (
                              <Reports group role={digest} />
                            )}
                          </>
                        }
                      />
                    }
                  />

                  <Route
                    path="/groups"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="گروه‌ها"
                        digest={digest}
                        childNode={<Groups />}
                      />
                    }
                  />
                  <Route
                    path="/projects"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="پروژه‌ها"
                        digest={digest}
                        childNode={<Projects />}
                      />
                    }
                  />
                  <Route
                    path="/create-project"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="پروژه‌های جهادی > پروژه جدید"
                        digest={digest}
                        childNode={<CreateProject />}
                      />
                    }
                  />
                  <Route
                    path="/update-project/:projectId"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="پروژه‌های جهادی > ویرایش پروژه"
                        digest={digest}
                        childNode={<CreateProject />}
                      />
                    }
                  />
                  <Route
                    path="/complete-area/:areaId"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="داشبورد > ساخت منطقه"
                        digest={digest}
                        childNode={<CompleteArea />}
                      />
                    }
                  />
                  <Route
                    path="/manage-notifs/:areaId"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="داشبورد > مدیریت اعلانات منطقه"
                        digest={digest}
                        childNode={<Notifications />}
                      />
                    }
                  />
                  <Route
                    path="/user-notifications"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="اعلانات منطقه"
                        digest={digest}
                        childNode={<MyNotifications />}
                      />
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="ثبت‌نام کنندگان"
                        digest={digest}
                        childNode={<Users />}
                      />
                    }
                  />
                  <Route
                    path="/reporters"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        title="گزارش گیرندگان"
                        digest={digest}
                        childNode={<Reporters />}
                      />
                    }
                  />

                  <Route
                    path="/trips"
                    element={
                      <Main
                        title="تاریخچه اردوها"
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<TripsPage />}
                      />
                    }
                  />
                  <Route
                    path="/users_trip"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<AccontsTrip />}
                      />
                    }
                  />
                  <Route
                    path="/drug"
                    element={
                      <Main
                        title="انبار داروخانه"
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<Drug />}
                      />
                    }
                  />
                  <Route
                    path="/equipment"
                    element={
                      <Main
                        title="تجهیزات"
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<Equipment />}
                      />
                    }
                  />
                  <Route
                    path="/accesses"
                    element={
                      <Main
                        title="دسترسی"
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<Accesses />}
                      />
                    }
                  />
                  <Route
                    path="/drugWarehouse"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<Drug notGroup />}
                      />
                    }
                  />

                  <Route
                    path="/area-drugs"
                    element={
                      <Main
                        title="انبار داروخانه"
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<DrugTableInArea />}
                      />
                    }
                  />

                  <Route
                    path="/area-equipments"
                    element={
                      <Main
                        title="انبار تجهیزات"
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<EquipmentsInArea />}
                      />
                    }
                  />

                  <Route
                    path="/equipmentWarehouse"
                    element={
                      <Main
                        setShowSidebar={setShowSidebar}
                        digest={digest}
                        childNode={<Equipment notGroup />}
                      />
                    }
                  />
                </>
              )}

              <Route path="/parvandeh" element={<Parvandeh />} />

              <Route
                path="/"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={
                      digest?.role === "JAHADI" ? (
                        <DashboardArea role={digest} />
                      ) : digest?.role === "GROUP" ? (
                        <DashboardTrip />
                      ) : digest?.role === "ADMIN" ? (
                        <AdminDashboard />
                      ) : (
                        <></>
                      )
                    }
                  />
                }
              />

              <Route
                path="/dashboard"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={
                      digest?.role === "JAHADI" ? (
                        <DashboardArea role={digest} />
                      ) : digest?.role === "GROUP" ? (
                        <DashboardTrip />
                      ) : digest?.role === "ADMIN" ? (
                        <AdminDashboard />
                      ) : (
                        <></>
                      )
                    }
                  />
                }
              />

              <Route
                path="/erja"
                element={
                  <Main
                    title="ارجاعات"
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Erja />}
                  />
                }
              />

              <Route
                path="/reception"
                element={
                  <Main
                    title="پذیرش بیماران"
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Reception />}
                  />
                }
              />
              <Route
                path="/education"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<AdultEducation />}
                  />
                }
              />
              <Route
                path="/childrenEducation"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<ChildrenEducation />}
                  />
                }
              />
              <Route
                path="/secretaries"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Secretaries />}
                  />
                }
              />
              <Route
                path="/insurer"
                element={
                  <Main
                    title="بیماران بدون پوشش بیمه"
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Insurer />}
                  />
                }
              />
              <Route
                path="/qarbal"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Qarbal />}
                  />
                }
              />
              <Route
                path="/module"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Qarbal />}
                  />
                }
              />
              <Route
                path="/drugTable"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    title="داروخانه"
                    digest={digest}
                    childNode={<DrugTableArea />}
                  />
                }
              />

              <Route
                path="/erjaTable"
                element={
                  <Main
                    setShowSidebar={setShowSidebar}
                    digest={digest}
                    childNode={<Erja />}
                  />
                }
              />
            </Routes>
          </MyProvider>
        </Suspense>
      </Box>
    </>
  );
}

export default App;
